
import { useState, useEffect } from 'react'
const SubcategoryContent = ({ data, searchParam }) => {
    // Still need to fix search when search category is change the user is not directed to scrolled category
    const [activeCategory, setActiveCategory] = useState(null)
    const handleClick = (data) => {
        if (data){
            const element = document.getElementById(data)
            if (element){
                element.scrollIntoView({
                    behavior: 'smooth'
                    })
                    setActiveCategory(data)
            }
        }

     }
    useEffect(() => {
        setActiveCategory(data[0].slug)
        return () => {
            setActiveCategory(null)
        }
    }, [data])

    // useEffect(() => {
    //     if (searchParam){
    //         handleClick(searchParam)
    //     }

    // }, [searchParam])

    const renderSubcategory = data.map((x, i) => {
        
        return(
            // <div key={x.id} dataslug={x.slug} className={`subcategory-item ${i === 0 ? "active-sub-item" : ""}`} onClick={handleClick}>
            <div key={x.id} dataslug={x.slug} className={`subcategory-item ${x.slug === activeCategory ? "active-sub-item" : ""}`} onClick={() => handleClick(x.slug)} >
                <span onClick={() => handleClick(x.slug)}>{x.name}</span>
            </div>
        )

    })
    return (
        <div className="subcategory-container">
            <div className="subcategory-outer-container">
                <div className="subcategory-inner-container">
                    {renderSubcategory}
                </div>
            </div>
        </div>
    )
}

export default SubcategoryContent